var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"outstanding-view"}},[_c('div',{staticClass:"outstanding-view-header"},[_c('h1',[_vm._v(_vm._s(_vm.$_('my_book_outstanding')))])]),_c('div',[_c('OutstandingHeader')],1),_c('div',[_c('OutstandingList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }